var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { t } from '@lingui/core/macro';
import { useToast } from '@pocketlaw/tetris';
import T from 'prop-types';
import { EntryKind } from 'shared/domains/apollo/generated/types';
import useCreateFolder from './useCreateFolder';
import { FileSystemManager } from '../FileSystemManager';
export function CreateFolderDialog(_a) {
    var { folder, onCreated, onClose } = _a, restProps = __rest(_a, ["folder", "onCreated", "onClose"]);
    const { addToast } = useToast();
    const [createFolder, { error }] = useCreateFolder({ onCreated });
    const handleSubmit = (values) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield createFolder(values);
            onClose();
            addToast({
                appearance: 'success',
                title: t({
                    message: 'Folder created',
                    comment: 'Message once a folder has been created in a workspace',
                }),
            });
        }
        catch (e) {
            addToast({
                appearance: 'danger',
                title: t({
                    message: 'An error occurred',
                    comment: 'Error message when creating a folder in workspaces.',
                }),
            });
        }
    });
    return (<FileSystemManager {...restProps} entryType={EntryKind.Folder} defaultParentId={folder === null || folder === void 0 ? void 0 : folder.id} error={error} onClose={onClose} onSubmit={handleSubmit}/>);
}
CreateFolderDialog.propTypes = {
    folder: T.shape({
        id: T.string.isRequired,
    }),
    onCreated: T.func,
    onClose: T.func.isRequired,
};
CreateFolderDialog.defaultProps = {
    folder: undefined,
    onCreated: undefined,
};
